import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import * as moment from 'moment';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';
import { UtilsService } from 'src/app/services/utils.service';
@Component({
  selector: 'app-electronic-billing-download-libro-iva',
  templateUrl: './electronic-billing-download-libro-iva.component.html',
  styleUrls: ['./electronic-billing-download-libro-iva.component.scss'],
})
export class ElectronicBillingDownloadLibroIvaComponent implements OnInit {
  value: any;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  dateFrom = '';
  dateTo = '';

  dateFromDropdown = '';
  dateToDropdown = '';

  errors: any = {
    type: true,
    dateFrom: false,
    dateTo: false,
    dropdownDate: false,
  };

  dropdownYears: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: ['Factura', 'Nota de crédito', 'Todos'],
  };

  radioButtonSelected = '2';

  dropdownMonths: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  dropdownYear: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  monthSelected = moment().locale('es').format('MMMM');
  yearSelected = moment().format('YYYY');
  typeSelected: string = '';

  datePickerFrom: QRDatePicker = { isDisplayedUp: true, calendarWidth: 200 };
  datePickerTo: QRDatePicker = { isDisplayedUp: true, calendarWidth: 200 };

  constructor(public utils: UtilsService) {}

  ngOnInit(): void {
    this.change.emit('disabled');
    this.monthSelected = this.utils.capitalize(this.monthSelected);
    this.yearSelected = moment().format('YYYY');
    this.dropdownMonths.options = this.utils.getMonths();
    this.dropdownYear.options = this.utils.getYears(2023, false);
    this.validateDate();
  }

  dropdownChange($event: string) {
    this.errors.type = true;
    if ($event) {
      switch ($event) {
        case 'Factura':
          this.typeSelected = 'FC';
          break;
        case 'Nota de crédito':
          this.typeSelected = 'NC';
          break;
        case 'Todos':
          this.typeSelected = '';
          break;
      }

      this.errors.type = false;
    }
    this.checkDisabled();
  }

  radioChange(event: any) {
    if (event && event == '1') {
      this.errors.dropdownDate = false;
      this.validateDateFrom();
      this.validateDateTo();
    } else {
      this.errors.dateTo = false;
      this.errors.dateFrom = false;
      this.validateDate();
    }
  }

  datepickerFromChange(e: string): void {
    this.errors.dateFrom = true;
    if (e) {
      this.dateFrom = e;
      console.log('✅ dateFrom: ', this.dateFrom);
    }
    this.validateDateFrom();
  }

  datepickerToChange(e: string): void {
    if (e) {
      this.dateTo = e;
      console.log('✅ dateTo: ', this.dateTo);
    }
    this.validateDateTo();
  }

  validateDateFrom() {
    this.errors.dateFrom = true;
    if (this.dateFrom) {
      this.errors.dateFrom = false;
      const today = moment().format('YYYY-MM-DD');
      if (this.dateFrom > today) this.errors.dateFrom = true;
      if (this.dateTo && this.dateFrom > this.dateTo)
        this.errors.dateFrom = true;
    }
    this.checkDisabled();
  }

  validateDateTo() {
    this.errors.dateTo = true;
    if (this.dateTo) {
      this.errors.dateTo = false;
      if (this.dateTo && this.dateFrom > this.dateTo) this.errors.dateTo = true;
    }
    this.checkDisabled();
  }

  dropdownChangeYear($event: any) {
    if ($event) this.yearSelected = $event;
    this.validateDate();
  }

  dropdownChangeMonth($event: any) {
    if ($event) this.monthSelected = $event;
    this.validateDate();
  }

  validateDate() {
    this.errors.dropdownDate = false;
    const month = moment().locale('es').month(this.monthSelected).format('MM');
    this.dateFromDropdown = this.yearSelected + '-' + month + '-01';
    this.dateToDropdown = moment(this.dateFromDropdown)
      .endOf('month')
      .format('YYYY-MM-DD');
    const todayMonth = moment().format('MM');
    if (Number(this.yearSelected) > Number(moment().format('YYYY')))
      this.errors.dropdownDate = true;
    if (Number(month) > Number(todayMonth)) this.errors.dropdownDate = true;
    this.checkDisabled();
  }

  checkDisabled() {
    let result = true;
    Object.keys(this.errors).forEach((key: any) => {
      result = result && !this.errors[key];
    });
    this.change.emit('disabled');
    if (result) {
      let dto = {
        fechaDesde: this.dateFrom,
        fechaHasta: this.dateTo,
        tipoCbte: this.typeSelected,
        isInvoices: this.value,
      };
      if (this.radioButtonSelected == '2') {
        dto.fechaDesde = this.dateFromDropdown;
        dto.fechaHasta = this.dateToDropdown;
      }
      this.change.emit(dto);
    }
  }
}
